import { type UseQueryResult, useQuery } from 'react-query';
import { VestingTypeService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetVestingTypeOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
      isCliffVesting: boolean | undefined;
      isStepVesting: boolean | undefined;
      isHybridVesting: boolean | undefined;
    }>
  | undefined,
  unknown
> => {
  const vestingTypeOptions = useQuery(
    ['getVestingTypeOptions'],
    async () => {
      return await handleRequest(VestingTypeService.getApiAwardApiAppVestingTypeVestingTypes());
    },
    {
      select: (data) => {
        const options = data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
            isCliffVesting: item.isCliffVesting,
            isStepVesting: item.isStepVesting,
            isHybridVesting: item.isHybridVesting,
          };
        });

        // Move "Specific Vesting" to the bottom of the list
        return options?.sort((a, b) => {
          if (a.label === 'Specific Vesting') return 1;
          if (b.label === 'Specific Vesting') return -1;
          return 0;
        });
      },
    }
  );

  return vestingTypeOptions;
};

export default useGetVestingTypeOptions;
